<div class="actions sdps-grid-fluid">
  <div class="col">
    @if (!isEmployeeAccount()) {
      <div>
        @if (instructionData.status == 'Active' || instructionData.status == 'Restarted') {
          <a
            href=""
            class="action-links stop"
            [ngClass]="isEmployeeAccount() ? 'action-links-disabled' : ''"
            (click)="!isEmployeeAccount() ? stopInstruction($event) : ''">
            Stop instruction now
          </a>
        }
        @if (instructionData.status == 'Pending') {
          <a
            href=""
            class="action-links stop"
            [ngClass]="isEmployeeAccount() ? 'action-links-disabled' : ''"
            (click)="!isEmployeeAccount() ? deleteInstruction($event) : ''">
            Cancel instruction now
          </a>
        }
      </div>
    }
    @if (isEmployeeAccount()) {
      <div>
        @if (instructionData.status == 'Active' || instructionData.status == 'Restarted') {
          <a
            class="action-links action-links-disabled stop">
            Stop instruction now
          </a>
        }
        @if (instructionData.status == 'Pending') {
          <a class="action-links action-links-disabled stop">
            Cancel instruction now
          </a>
        }
      </div>
    }
  </div>
  @if (instructionData.status !== 'Stopped') {
    <sdps-divider
      class="sdps-m-horizontal_x-small"
      variation="secondary"
    orientation="vertical"></sdps-divider>
  }
  @if (instructionData.status !== 'Cancelled') {
    <a href="" class="edit col-4" (click)="editInstruction($event)">
      <img [src]="editIcon" />
      <span class="action-links">Edit</span>
    </a>
  }
</div>
